module.exports = __webpack_public_path__ + "static/media/teamsDeleteIcon.803c132e.svg";